import React from 'react';
import ReportViewer from "./base/ReportViewer";

const VentesFolioDetaille = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"Ventesfoliodetaillereport"} />
        </div>
    );
}
export default VentesFolioDetaille;